import { EntityBase } from './entity-base';

/**
 * Represents a contact entity with email and mobile information.
 * @extends EntityBase
 * @class ContactEntity
 */
export class ContactEntity extends EntityBase {
  /**
   * The email address of the contact.
   * @type {string}
   * @default ""
   * @example "contact@example.com"
   */
  public email: string = "";

  /**
   * The mobile phone number of the contact.
   * @type {string}
   * @default ""
   * @example "+91 98765 43210"
   */
  public mobile: string = "";
}
